module.exports = __webpack_public_path__ + "assets/img/已消除.85b02211.svg";